import { generateStepConfig } from "@carrier-ecat/ngecat-commonworkflowui";
import { RULES, TAGS } from "../../constants/rules";
import { conditions, targetRequirements } from "../step2/sections/";
import { messages } from "../../constants/intl";
const step2 = generateStepConfig(RULES, [TAGS.UI_SEL, TAGS.UI_SEL_DC, TAGS.UI], {
    stepIndex: 1,
    type: 'default',
    name: messages.DETAILED_CONDITIONS,
    hasNavigation: false,
    sections: [
        targetRequirements,
        conditions
    ]
});
export default step2;
